import {
  addContractType,
  configContractRule,
  deleteContractType,
  getContractRuleConfig,
  getContractTypeList,
  updateContractType,
} from '../services';

export default {
  namespace: 'contractTypeList',
  state: {
    contractTypeList: [],
    contractConfigRules: {},
  },
  effects: {
    *getContractTypeList({ payload }, { call, put }) {
      const result = yield call(getContractTypeList, payload);
      yield put({
        type: 'update',
        payload: {
          contractTypeList: result,
        },
      });
      return result;
    },
    // 新增类型
    *addContractType({ payload }, { call, put }) {
      const result = yield call(addContractType, payload);
      yield put({
        type: 'update',
        payload: {
          contractTypeList: result,
        },
      });
      return result;
    },
    // 编辑类型
    *updateContractType({ payload }, { call, put }) {
      const result = yield call(updateContractType, payload);
      yield put({
        type: 'update',
        payload: {
          contractTypeList: result,
        },
      });
      return result;
    },
    // 删除类型
    *deleteContractType({ payload }, { call, put }) {
      const result = yield call(deleteContractType, payload);
      yield put({
        type: 'update',
        payload: {
          contractTypeList: result,
        },
      });
      return result;
    },
    // 配置规则
    *configContractRule({ payload }, { call, put }) {
      const result = yield call(configContractRule, payload);
      yield put({
        type: 'update',
        payload: {
          contractTypeList: result,
        },
      });
      return result;
    },
    // 获取合同规则配置
    *getContractRuleConfig({ payload }, { call, put }) {
      const result = yield call(getContractRuleConfig, payload);
      yield put({
        type: 'update',
        payload: {
          contractConfigRules: result?.result,
        },
      });
      return result;
    },
  },
  reducers: {
    update(state, { payload }) {
      return {
        ...state,
        ...payload,
      };
    },
  },
};
